import { useState } from 'react';
import { faqItems } from '@/mocks/data';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-secondary-600 tracking-[0.2em] uppercase font-label mb-3">
            FAQ
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于精品八区，您可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-lg border border-background-200/60 bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`text-sm text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                />
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}